import TemplatePanel from './components/template-panel'
import FieldPanel from './components/field-panel'
import DialogFooter from './components/dialog-footer'
// import DutyDialog from '@/public/components/query-table/drag-duty-dialog'
import NameDialog from '@/public/components/query-table/template-name-dialog'
import ShareDialog from '@/public/components/query-table/template-share-dialog'
import { DIALOG_DEFAULTS, TAB_PROPS, LEFT_PANEL_WIDTH, TEMPLATE_PROPS } from './constants'
import { initConfigs } from './data/init-data'
import { getTemplateListByIds, deleteTemplate } from './data/http-data'
import { executeSave, executeReset, executeSaveTemplate, executeSaveTemplateName } from './data/save-operations'
import { mergeConfigs } from './data/merge-configs'
// import { getCurrentFieldsConfig, executeSave, executeSaveAs } from './data/save-operations'

export default {
  name: 'KyeFieldSettings',
  components: { TemplatePanel, NameDialog, ShareDialog, FieldPanel, DialogFooter },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 是否显示模板列表
    showTemplatePanel: {
      type: Boolean,
      default: true
    },
    // 页签配置
    items: {
      type: Array,
      default: () => []
    },
    // 自定义应用回调
    onSave: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      menuId: '',
      genericIds: [],
      internaItems: [],
      activeTab: '0',
      templates: [],
      isEditTemplateName: false,
      templateModel: {
        batchId: '',
        templateName: ''
      },
    }
  },
  computed: {
    sharedTemplates() {
      return this.templates.map(item => {
        return {
          id: item.fieldTemplates.map(v => v.id).join(','),
          name: item.templateName || '未知名称',
          batchId: item.batchId
        }
      })
    }
  },
  watch: {},
  methods: {
    // 应用
    handleApply() {
      executeSave(this, { menuId: this.menuId, items: this.internaItems, saveFn: this.onSave, eventName: 'save' })
    },
    // 重置
    handleReset() {
      executeReset(this, { menuId: this.menuId, item: this.internaItems[this.activeTab], index: this.activeTab, eventName: 'reset' })
    },
    // 分享
    handleShare() {
      if (this.$refs.shareDialog) {
        this.$refs.shareDialog.show = true
      }
    },
    closeShareDialog () {
      if (this.$refs.shareDialog) {
        this.$refs.shareDialog.show = false
      }
    },
    // 取消
    handleCancel() {
      this.$emit('input', false)
    },
    // 打开
    async onOpen() {
      const { menuId, ids, items } = initConfigs(this, { items: this.items })
      this.genericIds = ids
      this.internaItems = items
      this.menuId = menuId
      this.getTemplateListByIds()
      this.setTemplateModel()
    },
    async getTemplateListByIds() {
      this.templates = await getTemplateListByIds(this.genericIds)
    },
    // 关闭
    onClose() {
      this.$emit('input', false)
    },
    // 保存
    handleSaveTemplate() {
      executeSaveTemplate(this, { menuId: this.menuId, items: this.internaItems, templateModel: this.templateModel, templates: this.templates })
    },
    // 另存为
    handleCreateTemplate() {
      this.templateModel.templateName = ''
      this.templateModel.batchId = ''
      this.showNameDialog()
    },
    // 模板选择
    handleTemplateChange(index) {
      this.setTemplateModel(index)
      const configs = this.templates[index].fieldTemplates
      this.internaItems = mergeConfigs(this.internaItems, configs)
    },
    async handleDeleteTemplate(index) {
      await deleteTemplate(this.templateModel.batchId)
      this.templates.splice(index, 1)
      this.setTemplateModel()
      this.$message.success('删除成功')
    },
    handleEditTemplate(index) {
      this.setTemplateModel(index)
      this.isEditTemplateName = true
      this.showNameDialog()
    },
    // 保存模板名称
    async handleSaveName() {
      executeSaveTemplateName(this, { menuId: this.menuId, items: this.internaItems, templateModel: this.templateModel, templates: this.templates, isEditName: this.isEditTemplateName })
    },
    shareUpdateTemplateName (tempateInfo) {
      const { batchId, templateName } = tempateInfo
      const _templateInfo = this.templates.find(item => item[TEMPLATE_PROPS.BATCH_ID] === batchId)
      _templateInfo && (_templateInfo.templateName = templateName)
    },
    setTemplateModel(index = -1) {
      const template = this.templates[index]
      this.templateModel.batchId = index !== -1 ? template[TEMPLATE_PROPS.BATCH_ID] : ''
      this.templateModel.templateName = index !== -1 ? template[TEMPLATE_PROPS.LABEL] : ''
    },
    showNameDialog (val = true) {
      if (this.$refs.nameDialog) {
        this.$refs.nameDialog.show = val
      }
    }
  },
  render() {
    const { value, activeTab, showTemplatePanel, templates, sharedTemplates, templateModel, internaItems } = this
    const dialogWidth = showTemplatePanel ? DIALOG_DEFAULTS.width : (parseInt(DIALOG_DEFAULTS.width) - parseInt(LEFT_PANEL_WIDTH)) + 'px'

    return (
      <el-dialog
        class="kye-field-settings kye-dialog__modal-in-tab"
        visible={value}
        title={DIALOG_DEFAULTS.title}
        width={dialogWidth}
        modalAppendToBody={DIALOG_DEFAULTS.modalAppendToBody}
        closeOnClickModal={DIALOG_DEFAULTS.closeOnClickModal}
        closeOnPressEscape={DIALOG_DEFAULTS.closeOnPressEscape}
        canResize={DIALOG_DEFAULTS.canResize}
        showFullScreenButton={DIALOG_DEFAULTS.showFullScreenButton}
        onClose={this.onClose}
        onOpen={this.onOpen}
        {...{ directives: [{ name: 'drag' }] }}
      >
        <div class="kye-field-settings-title" slot="title">
          <span class="el-dialog__title">{DIALOG_DEFAULTS.title}</span>
          {/* <DutyDialog
            ref="dutyAuth"
          /> */}
        </div>

        <div class="kye-field-settings-body">
          {/* 左侧模板面板 */}
          {showTemplatePanel && (
            <div class="kye-field-settings-left" style={{ width: LEFT_PANEL_WIDTH }}>
              <TemplatePanel
                data={templates}
                activeId={templateModel[TEMPLATE_PROPS.BATCH_ID] }
                onChange={this.handleTemplateChange}
                onDelete={this.handleDeleteTemplate}
                onEdit={this.handleEditTemplate}
              />
            </div>
          )}
          {/* 右侧内容区 */}
          <div class="kye-field-settings-right" style={!showTemplatePanel ? { width: '100%' } : {}}>
            <el-tabs value={activeTab} onTabClick={tab => { this.activeTab = tab }}>
              {
                internaItems.map((item, idx) => {
                  return (
                    <el-tab-pane label={item[TAB_PROPS.LABEL]} name={String(idx)}>
                      <FieldPanel
                        fields={item[TAB_PROPS.FIELDS]}
                      />
                    </el-tab-pane>
                  )
                })
              }
            </el-tabs>
          </div>
        </div>

        {/* 底部按钮 */}
        <DialogFooter
          slot="footer"
          disabledSaveTemplate={!templateModel.batchId}
          showSave={showTemplatePanel}
          showSaveAs={showTemplatePanel}
          onShare={this.handleShare}
          onReset={this.handleReset}
          onSave={this.handleSaveTemplate}
          onSaveAs={this.handleCreateTemplate}
          onApply={this.handleApply}
          onCancel={this.handleCancel}
        />

        {/* 模版命名 */}
        <NameDialog
          ref="nameDialog"
          escape={DIALOG_DEFAULTS.closeOnPressEscape}
          model={this.templateModel}
          onChange={this.handleSaveName}
        />

        <ShareDialog
          ref="shareDialog"
          escape={DIALOG_DEFAULTS.closeOnPressEscape}
          templates={sharedTemplates}
          shareRequestUrl="system.defineSearchFieldTemplate.shareTo"
          updateTemplateNameUrl="system.defineSearchFieldTemplate.updateFieldTemplate"
          businessType="1"
          onClose={this.closeShareDialog}
          onUpdateTemplateName={this.shareUpdateTemplateName}
        />
      </el-dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/field-settings.js